import Glide from '@glidejs/glide';

function initializeTestimonials() {
  const t = document.querySelectorAll('.testimonials');

  t.forEach((el) => {
    const g = el.querySelector('.glide');

    if (g && g.querySelector('ul').childElementCount > 1)
      new Glide('.glide', {
        type: 'carousel',
        autoplay: false,
      }).mount();
  });
}

export { initializeTestimonials };
